/* eslint-disable import/prefer-default-export */
export const MEMBERS_URL = `https://members${
  process.env.NEXT_PUBLIC_ENV === 'development' ? '.dev' : ''
}.playdapp.com`;
